const AUTO_CONFIGURATOR_SITE_CODES = new Set(['ADF', 'ROC']);

export function isAutoConfiguratorSite(siteCode: string) {
  return AUTO_CONFIGURATOR_SITE_CODES.has(siteCode);
}

export const TRUE_VALUE_STRING = 'true';
export const FALSE_VALUE_STRING = 'false';
